import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { StyleProp, TextStyle, TouchableOpacity, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from './MyAppText';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import Divider from './Divider';

interface HeaderProps {
    goBackAction?: () => void;
    actions?: React.ReactNode;
    title: string;
    zIndex?: number;
    titleStyle?: StyleProp<TextStyle>;
}

export default function Header(props: HeaderProps) {
    const { styles, theme } = useStyles(stylesheet);


    return <View style={[styles.container, { zIndex: props.zIndex }]}>
        <View style={styles.header}>
            {props.goBackAction &&
                <TouchableOpacity style={styles.goBackButton} onPress={props.goBackAction}>
                    <FontAwesomeIcon fontSize={22} icon={faArrowLeft as IconDefinition} color={theme.colors.iconColor} />
                </TouchableOpacity>
            }
            <MyAppText style={[styles.titleText, props.titleStyle]}>
                {props.title}
            </MyAppText>
            <View style={styles.actionsContainer}>
                {props.actions}
            </View>
        </View>
        <Divider color={theme.colors.neutral['300']} style={{ zIndex: -1 }} />
    </View>;
}

const stylesheet = createStyleSheet(theme => ({
    container: {
        gap: 8,
        paddingTop: 8,
        paddingBottom: 16,
    },
    header: {
        minHeight: 40,
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 16,
    },
    goBackButton: {
        justifyContent: 'center',
    },
    titleText: {
        fontSize: 22,
        flexGrow: 1,
        fontWeight: 'bold',
        color: theme.colors.iconColor,
        alignContent: 'center',
    },
    actionsContainer: {
        gap: 8,
        flexDirection: 'row',
    }
}));
